module.exports = __webpack_public_path__ + "static/media/10.41505a40.jpg";